import React, { useState, useEffect } from 'react'
import emitter from 'meinian-package/src/utils/emitter'
import useHeaderScroll from '../../../components/header/headerScrollWrap/useHeaderScroll'
import HeaderScrollWrap from '../../../components/header/headerScrollWrap'
import { SwitchPageTabContent, SwitchTabBorder } from '../../../components/switchTab'
import AuditSort from '../workbenchList/auditSort'

export const EmitterEvents = {
  sendWorkbenchHeader: 'sendWorkbenchHeader', // 工作台顶部发送
  receiveWorkBenchHeader: 'receiveWorkBenchHeader' // 工作台顶部接收
}

export default () => {
  const [pageSwitchOption, setPageSwitchOption] = useState([])
  const [listSwitchOption, setListSwitchOption] = useState([])
  const [tab, setTab] = useState(1)
  const [sortValue, setSortValue] = useState(null)
  const [auditSortValue, setAuditSortValue] = useState(null)
  const positionY = useHeaderScroll({
    onSend: () => onSend(),
    root: () => document.querySelector('#mn-workbench-list-page-tab')
  })

  const onSend = () => {
    emitter.emit(EmitterEvents.sendWorkbenchHeader, {
      start: false,
      tab,
      sortValue,
      auditSortValue
    })
  }

  useEffect(() => {
    emitter.on(EmitterEvents.receiveWorkBenchHeader, (message) => {
      setPageSwitchOption(message.options)
      setTab(message.tab)
      setSortValue(message.sortValue)
      setListSwitchOption(message.switchOption)
      setAuditSortValue(message.auditSortValue)
    })
    return () => {
      emitter.off(EmitterEvents.receiveWorkBenchHeader)
    }
  }, [])

  return <HeaderScrollWrap
    positionY={positionY}
    renderLeftBottom={() => <SwitchPageTabContent
      options={pageSwitchOption}
      value={tab}
      onChange={(val) => {
        setTab(val)
        setSortValue(null)
        emitter.emit(EmitterEvents.sendWorkbenchHeader, {
          start: true,
          tab: val,
          auditSortValue,
          sortValue: null
        })
      }}
    />}
    renderRightBottom={() => <div>
      {
          tab === 1 ? <SwitchTabBorder
            options={listSwitchOption}
            value={sortValue}
            onChange={(val) => {
              setSortValue(val)
              emitter.emit(EmitterEvents.sendWorkbenchHeader, {
                start: true,
                tab,
                auditSortValue,
                sortValue: val,
              })
            }}
          /> : <AuditSort
            value={auditSortValue}
            onChange={(item) => {
              setAuditSortValue(item?.value)
              emitter.emit(EmitterEvents.sendWorkbenchHeader, {
                start: true,
                tab,
                sortValue,
                auditSortValue: item?.value,
              })
            }}
          />
      }
    </div>}
  />
}
